import resolveEnv, { DEV, EVAL, FLUENTSMS, PROD, resolveDomain, TITLESOLUTIONS, UAT } from '@fluentsms/utils';

const config: {
  [domain: string]: {
    [env: string]: {
      uri: string;
      uriwss: string; // Poll interval in milliseconds for UserNotifications
    };
  };
} = {
  [FLUENTSMS]: {
    [DEV]: {
      uri: 'https://dev.fluentapi.titlesolutions.com/graphql',
      uriwss: 'wss://dev.fluentwebsockets.titlesolutions.com/subscriptions',
    },
    [UAT]: {
      uri: 'https://uat.fluentapi.titlesolutions.com/graphql',
      uriwss: 'wss://uat.fluentwebsockets.titlesolutions.com/subscriptions',
    },
    [EVAL]: {
      uri: 'https://eval.fluentapi.titlesolutions.com/graphql',
      uriwss: 'wss://eval.fluentwebsockets.titlesolutions.com/subscriptions',
    },
    [PROD]: {
      uri: 'https://fluentapi.titlesolutions.com/graphql',
      uriwss: 'wss://fluentwebsockets.titlesolutions.com/subscriptions',
    },
  },
  [TITLESOLUTIONS]: {
    [DEV]: {
      uri: 'https://dev.fluentapi.titlesolutions.com/graphql',
      uriwss: 'wss://dev.fluentwebsockets.titlesolutions.com/subscriptions',
    },
    [UAT]: {
      uri: 'https://uat.fluentapi.titlesolutions.com/graphql',
      uriwss: 'wss://uat.fluentwebsockets.titlesolutions.com/subscriptions',
    },
    [EVAL]: {
      uri: 'https://eval.fluentapi.titlesolutions.com/graphql',
      uriwss: 'wss://eval.fluentwebsockets.titlesolutions.com/subscriptions',
    },
    [PROD]: {
      uri: 'https://fluentapi.titlesolutions.com/graphql',
      uriwss: 'wss://fluentwebsockets.titlesolutions.com/subscriptions',
    },
  },
};

export default config[resolveDomain()][resolveEnv()];
